import styled from 'styled-components';
import { device } from 'styles/breakpoints';

export const NotDTCStepStartWrapper = styled.div`
  > h3 {
    font-size: 20px;
    line-height: 28px;
    color: rgba(71, 69, 64, 0.7);
    font-weight: 400;
    font-family: 'Helvetica Neue', sans-serif;
  }
  > h2 {
    font-size: 24px;
    line-height: 32px;
    font-weight: 400;
    color: rgb(71, 69, 64);
    margin-top: 20px;
    margin-bottom: 28px;
    font-family: 'Helvetica Neue', sans-serif;
  }
  > p {
    font-size: 20px;
    line-height: 28px;
    color: rgba(71, 69, 64, 0.7);
    font-style: italic;
    font-weight: bold;
    font-family: 'Helvetica Neue', sans-serif;
  }
  @media ${device.laptop} {
    > h2 {
      font-size: 18px;
      line-height: 26px;
      margin: 10px 0;
    }
    > p {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const NotDTCStepStartBoxies = styled.div`
  margin-top: 32px;
  display: flex;
  > div {
    width: 100%;
    max-width: 174px;
    position: relative;
    border-radius: 4px;
    background-color: rgba(100, 78, 2, 0.1);
    box-shadow: rgba(100, 78, 2, 0.6) 0px 0px 0px 1px inset;
    color: rgb(100, 78, 2);
    outline: currentcolor none 0px;
    padding: 8px;
    transition: 0.1s all ease-out;
    cursor: pointer;
    opacity: 1;
    &:not(:first-child) {
      margin-left: 174px;
    }
    &:hover {
      background-color: rgba(100, 78, 2, 0.3);
    }
    > a {
      display: block;
    }
  }
  @media ${device.laptop} {
    margin-top: 16px;
    > div {
      min-width: 120px;
      &:not(:first-child) {
        margin-left: 10px;
      }
    }
  }
`;

export const NotDTCStepStartBoxImage = styled.div`
  display: flex;
  justify-content: center;
  > img {
    width: 152px;
    height: 152px;
  }
  @media ${device.tablet} {
    > img {
      width: 100px;
      height: 100px;
    }
  }
`;

export const NotDTCStepStartBoxInfo = styled.div`
  margin-top: 8px;
  display: flex;
  > span {
    width: 24px;
    height: 24px;
    border-radius: 2px;
    font-size: 12px;
    line-height: 16px;
    border: 1px solid rgba(100, 78, 2, 0.6);
    background-color: rgba(245, 250, 248, 0.8);
    color: rgb(100, 78, 2);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
  }
  > p {
    margin-left: 8px;
    color: rgb(100, 78, 2);
  }
  @media ${device.tablet} {
    word-break: break-all;
  }
`;
